import register from 'ShopUiBundle/modules/app/registry';
import 'ShopUiBundle/components/molecules/bullets-chooser';
import 'ShopUiBundle/components/molecules/zoom-image';
import './zoom-images.scss';

// tslint:disable-next-line
register('zoom-images', () => import(/* webpackMode: "lazy" */'./zoom-images'));
